import { TrimCardStatusEnum } from "../../Enum/wfx.enum"

export class ImageUplaodReq {
    id: number
    modifiedOriginalName: string

    constructor(
        id: number,
        modifiedOriginalName: string
    ) {
        this.id = id
        this.modifiedOriginalName = modifiedOriginalName
    }
}


export class StyleStautsReq {
    id: number
    status: TrimCardStatusEnum

    constructor(
        id: number,
        status: TrimCardStatusEnum
    ) {
        this.id = id
        this.status = status
    }
}
